import { getItem } from 'mini-localstorage';
import { getStore } from '../store/Store';
import { WHATS_NEW_ITEMS_LIST } from '../utils/constants';

/**
 * @returns true if there are new items in the store
 * that are not present in the local storage
 */
export const areUnseenWhatsNewItemsPresent = () => {
    const itemsInLocalStorage = getItem(WHATS_NEW_ITEMS_LIST);
    return !getStore().whatsNewItems?.every(item => itemsInLocalStorage?.includes(item));
};
